export default {  
    "Forgot the password": "Esqueci a senha",
    "Enter": "ENTRAR",
    "Password": "Senha",
    "Forgot password?": "Esqueci a senha",
    "Back": "Voltar",
    "Equipments": "Equipamentos",
    "Settings": "Configurações",
    "Filters": "Filtros",
    "Search": "Buscar",
    "Device model": "Modelo do equipamento",
    "Software version": "Versão do Software",
    "Clear": "Limpar",
    "Filter by serial number, module ...": "Filtrar por número de série, módulo ...",
    "Register date": "Data de cadastro",
    "Mode": "Modo",
    "Client": "Cliente",
    "Modules": "Módulos",
    "History": "Histórico",
    "Serial number": "Número de série",
    "Register": "Cadastrar",
    "Regulatory target": "Alvo regulatório",
    "Last maintenance": "Última manutenção",
    "Software version": "Versão do software",
    "Equipment": "Equipamento",
    "Activation keys": "Chave de ativação",
    "Change reason": "Tipo de alteração",
    "Responsible": "Responsável",
    "Fill in the fields below to register a new equipment": "Preencha os campos para registrar um novo equipamento",
    "Model": "Modelo",
    "Regulatory mode": "Modo regulatório",
    "Identity file": "Arquivo de identidade",
    "File specifications": "Especificações do Arquivo",
    "The file must be in .json format with the following structure": "O arquivo deve estar no formato .json com a seguinte estrutura",
    "Contains 'device' object or keys at root": "Contém objeto 'device' ou chaves na raiz",
    "All keys below must not be empty": "Todas as chaves abaixo não devem estar vazias",
    "Logout": "Sair",
    "Confirm Associate": "Associar",
    "Send order": "Enviar pedido",
    "Associate": "Associar como distribuidor/cliente",
    "Modules order": "Pedido de módulols",
    "Fill in the data below to associate the equipment with the distributor:":"Preencha os dados abaixo para associar o equipamento ao distribuidor:",
    "Distributor": "Distribuidor",
    "State": "Estado",
    "Select an address": "Selecione um endereço",
    "Include new address": "Incluir novo endereço",
    "Street": "Rua",
    "Number": "Número",
    "Complement": "Complemento",
    "District": "Cidade",
    "UF": "Estado",
    "Country": "País",
    'Register date': "Data cadastro",
    'Mode': 'Modo',
    'Pim serial number': 'Pim serial number',
    'AM serial number': 'AM serial number',
    'Ventilation serial number': 'Número de série Ventilação',
    'Pim mac address one': 'Pim mac address one',
    'Pim mac address two': 'Pim mac address two',
    "We will get back to you as soon as possible about your order.": "Iremos retornar o quanto antes sobre o seu pedido",
    "Modules order has created successfully!": "A ordem dos módulos foi criada com sucesso!",
    "Confirm the changes": "Confirmar alterações",
    "Before changes": "Antes das alterações",
    "After changes": "Depois das alterações",
}